import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTypescriptComponent } from './simple-icons-typescript.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTypescriptComponent ],
    exports:      [ SimpleIconsTypescriptComponent ],
    bootstrap:    []
})
export class SimpleIconsTypescriptModule {}
